<template>
	<div class="headBox">
		<div class="head">
			<div class="headBack">
				<img src="@/images/TOP.png" />
			</div>
			<div class="headCont">
				<img src="@/images/logo.png" class="headLogo" @click="toIndex" /> 
				<div class="headMenu" v-show="$route.name != 'search'">
					<div class="headMenuline">
						<el-input placeholder="请输入要搜索的课程、作业、考试" v-model="searchInput" style='width: 320px;'>
							<el-button slot="append" icon="el-icon-search" @click='toSearch'></el-button>
						</el-input>
					</div>
				</div>
				<div class="headMenu" v-show="false">
					<div class="headMenuline" v-show='userinfo.name'>
						欢迎您，{{userinfo.name}}
					</div>
					<div class="headMenuline" v-show='userinfo.name' @click="tocenter(1)">
						<img src="@/images/icon_user.png" alt="" />个人中心
					</div>
					<div class="headMenuline" v-show='userinfo.name' @click="tologout()">
						<img src="@/images/icon_exit.png" alt="" />退出
					</div>
					<div class="headMenuUser" v-show='!userinfo.name' @click="tologin">
						<div style="color: #FFFFFF;">
							{{userinfo.name||'请登录'}}
						</div>
					</div>
				</div>
			</div>
			<div class="headNav">
				<img src="@/images/headnva.png" class="headNavback" />
				<div class="headNavCont">
					<div class="headNavCont_item" @click="toNav(item)" :class="item.routenames.includes(routeName)?'active':''" v-for="item in navlist">
						<span>{{item.name}}</span>
						<img src="@/images/nav_back.png" />
					</div>
				</div>
			</div>
		</div>
		<!--登录页面-->
		<div class="form" v-show='loginback || loging'>
			<div class="login_back">
				<i class="login_close el-icon-close" @click="cancelBack"></i>
				<h2>用户登录</h2>
				<el-form ref="loginForm" :model="user" :rules="rules" class="loginForm">
					<el-form-item prop="username" class="elform login_form">
						<el-input prefix-icon="el-icon-user-solid" v-model="user.username" placeholder="请输入用户名/学号" class="input login_input"></el-input>
					</el-form-item>
					<el-form-item prop="password" class="elform login_form_1">
						<el-input prefix-icon="el-icon-lock" type="password" v-model="user.password" placeholder="请输入密码" class="input login_input" @keyup.enter.native="submitForm()"></el-input>
					</el-form-item>
					<el-button type="primary" class="loginButton" @click="submitForm()">登录</el-button>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth'
	import { login, getInfo } from "@/api/user"
	import { mapGetters } from "vuex"
	import RequestUtils from "@/utils/im/RequestUtils";
	import conf from "@/utils/im/index";
	import StoreUtils from "@/utils/im/StoreUtils";
	import { logout } from "@/utils/im/ChatUtils";
	export default {
		name: 'headmain',
		data() {
			return {
				userinfo: {},
				loginback: false,
				showmenu: false,
				showback: false,
				routeName: '',
				searchInput: '',
				navlist: [{
					name: '首页',
					routenames: ['/', 'index'],
					path: 'index',
				}, {
					name: '专业园地',
					routenames: ['plot'],
					path: 'plot',
				}, {
					name: '课程中心',
					routenames: ['courses'],
					path: 'courses',
				}, {
					name: '在线作业',
					routenames: ['tasklist'],
					path: 'tasklist',
				}, {
					name: '交流互动',
					routenames: ['communication'],
					path: 'communication',
				}, {
					name: '统计分析',
					routenames: ['center13'],
					path: 'center',
					query: {
						activeTab: 13
					},
				}, {
					name: '在线直播',
					routenames: ['livelist'],
					path: 'livelist',
				}, {
					name: '新闻动态',
					routenames: ['news'],
					path: 'news',
				}],
				user: {
					username: "",
					password: ""
				},
				rules: {
					username: [{
						required: true,
						message: "请输入用户名",
						trigger: "blur"
					}],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}]
				}
			}
		},
		computed: {
			...mapGetters([
				'loging'
			])
		},
		watch: {
			loging(val) {
				if(val) {
					this.relogin()
				}
			},
			$route(val) {
				this.routeName = val.name;
				if(val.name == 'center' && val.query && val.query.activeTab) {
					this.routeName = this.routeName + val.query.activeTab
				}
				this.showmenu = false;
			},
		},
		mounted() {
			this.getinfo();
			this.tiggermenu();
			this.headback();
		},
		methods: {
			toSearch() {
				if(!this.searchInput) {
					this.$message({
						type: 'error',
						message: '请输入内容'
					})
					return
				} else {
					this.$router.push({
						name: 'search',
						query: {
							name: this.searchInput
						}
					})
				}
			},
			toNav(item) {
				var token = getStorageToken();
				if(token) {
					if(this.$route.name != item.path) {
						this.showmenu = false;
						if(!item.query) {
							this.$router.push({
								name: item.path
							})
						} else {
							this.$router.push({
								name: item.path,
								query: item.query
							})
						}
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			headback() {
				var that = this;
				$(window).on('scroll', function() {
					var scrollTop = window.scrollY;
					if(that.$route.name == 'index' || that.$route.name == '/') {
						if(scrollTop > 540) {
							that.showback = true
						} else {
							that.showback = false
						}
					}
				})
			},
			handleCommand(command) {
				if(command == 'first') {
					this.tologin()
				}
				if(command == 'second') {
					this.tocenter(0)
				}
				if(command == 'third') {
					this.tologout()
				}
			},
			toName(name) {
				var token = getStorageToken();
				if(token) {
					if(this.$route.name != name) {
						this.showmenu = false;
						this.$router.push({
							name: name
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			tomenu() {
				this.showmenu = !this.showmenu;
			},
			tiggermenu() {
				var that = this;
				$('#app').on('click', function() {
					that.showmenu = false;
				})
			},
			toIndex() {
				if(this.$route.name != 'index') {
					this.$router.push({
						name: 'index'
					})
				}
			},
			relogin() {
				window.localStorage.removeItem('token')
				this.loginback = true;
			},
			tologin() {
				window.localStorage.removeItem('token')
				this.loginback = true;
			},
			tologout() {
				try {
					logout(this);
				} catch(err) {}
				window.localStorage.removeItem('token')
				location.reload()
			},
			tocenter(type) {
				if(this.$route.name != 'center') {
					this.showmenu = false;
					this.$router.push({
						path: '/center',
						query: {
							activeTab: type
						}
					});
				}
			},
			cancelBack() {
				this.loginback = false;
				this.$store.dispatch('user/openLogin', {
					loging: false
				})
			},
			getinfo() {
				var token = getStorageToken();
				if(token) {
					getInfo(token).then(res => {
						if(res.code == 'OK') {
							this.userinfo = res.data
							// localStorage.setItem('nickname', res.data.name)
							window.localStorage.setItem('username', res.data.name)
						}
					})
				}
			},
			submitForm() {
				this.$refs.loginForm.validate(valid => {
					if(valid) {
						login({
							username: this.user.username,
							password: this.user.password
						}).then(res => {
							if(res.code == 'OK') {
								localStorage.setItem('token', res.data);
								getInfo(res.data).then(result => {
									window.localStorage.setItem('username', result.data.name)
								})
								this.$store.dispatch('user/openLogin', {
									loging: false
								});
								this.loginback = false;
								//location.reload()
								this.imLogin();
							} else {
								this.$message({
									message: res.msg,
									type: 'error'
								})
							}
						});
					}
				})
			},
			imLogin() {
				let im = RequestUtils.getInstance();
				im.login(this.user.username.trim(), '123456', this).then(token => {
					StoreUtils.setToken(token);
					return im.request(conf.getInitUrl(), new FormData());
				}).then(response => {
					return response.json();
				}).then(json => {
					//个人信息
					this.$store.commit("setUser", json.me);
					//好友
					this.$store.commit("setUserFriendList", json.friends);
					//群
					let chatMap = new Map();
					var groups = json.groups;
					groups.map(group => {
						group.unMessageFlag = group.unMessageFlag == '1' ? true : false
						chatMap.set(group.id, group);
					})
					this.$store.commit("setChatGroupList", groups);
					this.$store.commit("setChatMap", chatMap);
					// 刷新
					location.reload()
				}).catch(function(error) {
					//location.reload()
					console.log(error)
				});
			},
			getNickname() {
				return localStorage.nickname && localStorage.nickname !== 'undefinded' ? localStorage.nickname : '游客'
			},
		},
	}
</script>
<style scoped>
	.form {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 12;
		background: rgba(0, 0, 0, 0.4);
	}
	
	.login_input {
		width: 27%;
	}
	
	.login_back {
		height: 280px;
		width: 290px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		border-radius: 10px;
		overflow: hidden;
		background: #FFFFFF;
		padding: 30px 40px;
	}
	
	.login_close {
		position: absolute;
		right: 20px;
		top: 20px;
		font-size: 20px;
		color: #333333;
		cursor: pointer;
	}
	
	.login {
		width: 50%;
		height: 50%;
		background-color: #FFFFFF;
		background-size: 100% 100%;
		overflow: hidden;
		position: relative;
	}
	
	.form .login_form {
		width: 320%;
		margin: 0 auto;
		margin-top: 11%;
		margin-bottom: 10%;
		margin-left: 7%;
	}
	
	.form .login_form_1 {
		width: 320%;
		margin: 0 auto;
		margin-left: 7%;
	}
	
	.form h2 {
		padding-top: 4%;
		width: 70%;
		margin-left: 40%;
		/*margin-top: 20%;*/
		margin: 0 auto;
		text-align: center;
	}
	
	.loginButton {
		margin-top: 11% !important;
		margin-bottom: 8% !important;
		width: 86%;
		margin: 0 auto;
		margin-left: 7%;
	}
</style>